import { DEFAULT_MESSAGES, LOADING_TYPES, REPORT_MESSAGES } from "./constants";

export function messagesForType(type) {
  if (type === LOADING_TYPES.REPORT) return REPORT_MESSAGES;
  if (type === LOADING_TYPES.FIRESTORE) {
    return ["Fetching Firebase data…", "Loading documents…", "Syncing with cloud…", ...DEFAULT_MESSAGES];
  }
  if (type === LOADING_TYPES.NAVIGATION) {
    return ["Loading page…", "Preparing view…", "Almost ready…"];
  }
  if (type === LOADING_TYPES.UPLOAD) {
    return ["Uploading…", "Processing file…", "Saving to Firebase…", "Almost done…"];
  }
  if (type === LOADING_TYPES.IMPORT) {
    return ["Reading file…", "Validating rows…", "Checking duplicates…", "Preparing preview…"];
  }
  if (type === LOADING_TYPES.EXPORT) {
    return ["Preparing export…", "Building file…", "Finalizing download…"];
  }
  if (type === LOADING_TYPES.BATCH) {
    return ["Processing batch…", "Applying changes…", "Almost done…"];
  }
  if (type === LOADING_TYPES.AUTH) {
    return ["Signing in…", "Verifying credentials…", "Loading your workspace…"];
  }
  return DEFAULT_MESSAGES;
}

export function pickMessage(type, index) {
  const list = messagesForType(type);
  return list[index % list.length];
}
